export default {
    "pages.account.info": '用戶資料',
    "pages.welcome.title": "歡迎來到國際天利有限公司",
    "pages.certification.title": "專業認證",
    "pages.certification.description": "多項國際認證，品質保證",
    "pages.support.title": "技術支持",
    "pages.support.description": "24/7全天候技術支持",
    "pages.global_service.title": "全球服務",
    "pages.global_service.description": "覆蓋亞太地區主要市場",
    "pages.feature.learn_more": "了解更多",
    "pages.contact.title": "聯繫我們",
    "pages.contact.company_address": "公司地址",
    "pages.contact.business_hours": "工作時間",
    "pages.contact.email": "電子郵箱",
    "pages.contact.phone": "聯繫電話",
    "pages.contact.address": "香港上環永樂街116-118號祥順大廈3樓A室",
    "pages.contact.hours": "週一至週五: 9:00 - 18:00",
    "pages.welcome.alertMessage": "全新耐用元件，速度更快，強度更高。",
    "pages.welcome.description": "我們專注於再生能源產品的生產、分銷和工程解決方案。提供批發電動汽車充電站銷售以及綜合能源系統的建造和維護服務。",
    "pages.admin.subPage.title": "訪問受限：僅限管理員查看。",
    "pages.notFind.description": "未找到數據，請檢查您的請求。",
    "pages.404.subTitle": "找不到頁面",
    "pages.404.buttonText": "返回",

    "user.auth.username": "使用者名稱",
    "user.auth.pwd": "密碼",
    "user.auth.confirmed_pwd": "確認密碼",
    "user.auth.forgotten_pwd": "忘記密碼",
    "user.auth.username.alert": "請輸入使用者名稱！",
    "user.auth.pwd.alert": "請輸入密碼！",
    "user.auth.error_message": "帳戶或密碼錯誤",
    "user.auth.success": "登入成功",
    "user.auth.error": "登入失敗",
    "user.auth.remember_me": "記住我",
    "user.auth.email_format": "電子郵件格式無效",
    "user.auth.forgotten_sent_success": ": 已成功發送忘記密碼請求",
    "user.auth.captcha": "驗證碼",
    "user.auth.fetch_captcha": "獲取驗證碼",
    "user.auth.captcha_retry": "請在",
    "user.auth.captcha_sec": "秒後重試",
    "user.auth.captcha_empty": "驗證碼欄位不能為空。",
    "user.auth.reset.unmatch_confirmed_pwd": "密碼不匹配。",
    "user.auth.reset.pwd_rule": "密碼長度須不少於 8 個字元，且必須包含至少一個字母及一個非字母字符。",
    "user.auth.reset.pwd_placeholder": "請輸入並確認您的新密碼。",
    "user.auth.reset.pwd": "新密碼",
    "user.setting": "個人設定",
    "user.logout": "登出",
    "user.uid": "Id",
    "user.email": "電郵",
    "user.tel": "電話",
    "user.nickname": "暱稱",
    "user.admin": "管理員",
    "user.admin_true": "是",
    "user.admin_false": "否",
    "user.account_status": "帳戶狀態",
    "user.account_status_active": 'Active',
    "user.account_status_locked": '已鎖定',
    "user.account_status_suspended": '暫停',
    "user.lock_date": "鎖定日期",
    "user.deleted_at": "deleted_at",
    "user.account.avatar": "頭像",

    "del_acc.title": "刪除 Thunder Power 帳戶",
    "del_acc.parapgrah1": "在刪除您的帳戶之前，請務必了解此操作是不可復原的。",
    "del_acc.parapgrah2": "確認刪除即表示您承認將永久無法檢索您的帳戶及所有相關資訊和記錄歷史。其中包括個人資料、服務使用記錄、交易詳情，以及您創建或分享的任何內容。",
    "del_acc.parapgrah3": "如果您希望保留任何數據，請在開始刪除程序前備份您的資料。帳戶刪除後，將無法恢復。此外，請注意，您的帳戶內剩餘的餘額將以支票形式退還。為確保退款順利處理，請提供必要的資訊。",
    "del_acc.parapgrah4": "一旦您提交帳戶刪除請求，您的帳戶將立即關閉。請注意，剩餘餘額的退款處理可能需要最多 180 個工作日。",
    "del_acc.parapgrah5": "如有任何疑問或需要協助，請聯繫我們的客服團隊以獲取更多資訊。",
    "del_acc.btn": "刪除帳戶",
    "del_acc.confirmation": "我確認刪除帳戶是永久性且不可復原的操作，並同意上述條款。",
    "del_acc.req": "您必須確認才能繼續。",
    "del_acc.refund_address": "香港郵寄地址（用於餘額退款支票）",
    "del_acc.payee_name": "收款人姓名",
    "del_acc.refund_address_table": "退款地址",
    "del_acc.remark": "備註",
    "del_account_status.pending": "待辦的",
    "del_account_status.processing": "處理",
    "del_account_status.completed": "完成",
    "del_account_confirm_message": "您確定要刪除您的帳戶嗎？一旦確認，您將無法繼續使用我們的服務。",
    "del_account_process_message": "我們已收到您的請求並開始處理退訂流程。此外，您將無法繼續使用我們的服務。您的帳戶餘額將在 7–14 個工作日內以支票方式退款給您。"
}